"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ColorIndicator = _interopRequireDefault(require("../../../../deprecated/atoms/color-indicator/ColorIndicator"));
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
function getTextColor(backgroundColor) {
  var brightness = 255;
  var brightnessThreshold = 165;
  try {
    var c = parseInt(backgroundColor.slice(1), 16);
    var r = c >> 16;
    var g = c >> 8 & 0x00ff;
    var b = c & 0x0000ff;
    brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  } catch (e) {}
  return brightness < brightnessThreshold ? _globalTokens.globalColor.text.content.onDark : _globalTokens.globalColor.text.content.main;
}
var StyledIdIcon = _styledComponents.default.div.withConfig({
  displayName: "ColoredIdIcon__StyledIdIcon",
  componentId: "sc-1wfpltb-0"
})(["display:inline-block;", ";border-radius:", ";padding:", " ", ";white-space:nowrap;"], _tokens.default.sky.sys.font.subheading['2'], _globalTokens.globalBorder.radius['2'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['200']);
function ColoredIdIcon(_ref) {
  var children = _ref.children,
    color = _ref.color;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIdIcon, {
    style: {
      backgroundColor: color,
      color: getTextColor(color)
    },
    children: children
  });
}
_ColorIndicator.default.defaultProps = {
  color: _globalTokens.globalColor.id['4']
};
var _default = exports.default = ColoredIdIcon;